import React from 'react'


// Styles
import './App.css';



// Thirds.
import { 
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom'
import HomeTemplate from '../Home/Home'




function App() {
  return (
    <div className="App">

      <Router>

        <Routes>


          <Route path='/' element={ <HomeTemplate /> }  />


        </Routes>

      </Router>

    </div>
  );
}

export default App;
